import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, label, title, sub, className = "", titleClass = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <p className="eyebrow flex items-center gap-3">
        <span className="text-zinc-400">{index}</span>
        <span className="h-px w-10 bg-emerald-400/60" />
        {label}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-[#f1f0ea] ${titleClass}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base md:text-lg text-zinc-300 leading-relaxed max-w-2xl">{sub}</p>
      </Reveal>
    )}
  </div>
);
